"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.invokeQuery = void 0;
const PayloadUtils_1 = require("../common/PayloadUtils");
const axios_1 = __importDefault(require("axios"));
const getApiHost_1 = require("./getApiHost");
function invokeQuery(query) {
    return __awaiter(this, void 0, void 0, function* () {
        let rawRes = yield (axios_1.default.post((0, getApiHost_1.getApiHost)() + '/query', query));
        if (rawRes.data.status != PayloadUtils_1.QueryResponseStatus.OK) {
            throw new Error(`${PayloadUtils_1.QueryResponseStatus[rawRes.data.status]}: ${rawRes.data.message}`);
        }
        return rawRes.data;
    });
}
exports.invokeQuery = invokeQuery;
